import { Status, UpdateStatus, CheckDevice } from "./Config/Status.js";
import CustomProperty from "./Modules/CustomProperty.js";
import Animation from "./Modules/Animation.js";
import DrawerMenu from "./Modules/DrawerMenu.js";
import Modal from "./Modules/Modal.js";
import MediaPlay from "./Modules/MediaPlay.js";
import VideoControl from "./Modules/VideoControl.js";
import SmoothScroll from "./Modules/SmoothScroll.js";
import Cursor from "./Modules/Cursor.js";
import * as Slider from "./Modules/Slider.js";


import Home from "./Page/Home/App.js";

const page = Status.page.toLowerCase();

// init
CheckDevice();
CustomProperty();
Animation.init();
DrawerMenu.init();
Modal.init();
Cursor.init();
SmoothScroll();
// Slider.BasicSlider();
if(Status.isLocal) {
  // Debug();
}


// preload
window.addEventListener("DOMContentLoaded", () => UpdateStatus.load());


// load
window.addEventListener("load", () => UpdateStatus.load());
window.addEventListener("load", () => MediaPlay.init());
window.addEventListener("load", () => VideoControl.init());

// resize
window.addEventListener("resize", () => UpdateStatus.resize());
window.addEventListener("resize", () => CheckDevice());
window.addEventListener("resize", () => CustomProperty());

// scroll
window.addEventListener("scroll", () => UpdateStatus.scroll());

// orientationchange
window.addEventListener("orientationchange", () => UpdateStatus.resize());


switch(page) {
  case "home":
    Home.init();
    // window.addEventListener("beforeunload", () => ScrollTop(false));
    window.addEventListener('load', () => Home.load());
    window.addEventListener('resize', () => Home.resize());
    window.addEventListener('scroll', () => Home.scroll());
  break;
}

